export const lang = {
  fr: {
    // Navigation
    nav: {
      home: 'Accueil',
      services: 'Services',
      projects: 'Professionnel',
      about: 'À propos',
      contact: 'Contact',
      dashboard: 'Tableau de bord'
    },
    
    // Home page
    home: {
      hero: {
        title: '2RENOV - Votre Partenaire de Rénovation',
        subtitle: 'Transformons vos espaces en lieux d\'exception',
        cta: 'Découvrir nos services'
      },
      services: {
        title: 'Nos Services',
        residential: 'Rénovation Résidentielle',
        commercial: 'Rénovation Commerciale',
        interior: 'Design d\'Intérieur',
        exterior: 'Rénovation Extérieure'
      }
    },

    // Dashboard
    dashboard: {
      title: 'Tableau de Bord',
      kpis: {
        projects: 'Projets en cours',
        completed: 'Projets terminés',
        clients: 'Clients satisfaits',
        revenue: 'Chiffre d\'affaires'
      }
    },

    // Contact
    contact: {
      title: 'Contactez-nous',
      form: {
        name: 'Nom',
        email: 'Email',
        message: 'Message',
        submit: 'Envoyer',
        projectType: 'Type de projet',
        description: 'Description du projet',
        budget: 'Budget estimé',
        timeline: 'Délai souhaité',
        photos: 'Photos du projet',
        phone: 'Téléphone'
      },
      quoteRequest: {
        title: 'Demande de devis',
        subtitle: 'Remplissez ce formulaire pour obtenir un devis gratuit pour votre projet de rénovation',
        submit: 'Demander un devis'
      }
    },

    // Images
    images: {
      categories: {
        default: '',
        types: {
          complete: '',
          multiSector: '/images/categories/renovation-complete-appartement.jpg'
        },
        interior: {
          painting: '',
          flooring: '',
          plumbing: '',
          electrical: '',
          partitions: '',
          interiorJoinery: '',
          kitchen: '',
          bathroom: '',
          heating: '',
          interiorInsulation: '',
          masonry: '',
          carpentry: '',
          plastering: '',
          tiling: '',
          woodwork: ''
        },
        exterior: {
          facade: '',
          roofing: '',
          exteriorJoinery: '',
          terrace: '',
          fencing: '',
          garden: '',
          exteriorInsulation: '',
          drainage: '',
          foundation: '',
          exteriorMasonry: ''
        },
        professional: {
          complete: '',
          multiSector: '/images/categories/renovation-complete-appartement.jpg',
          restoration: '',
          parking: '',
          office: '',
          security: '',
          access: ''
        }
      }
    },

    services: {
      types: {
        title: "Types de Rénovation",
        complete: {
          title: "Rénovation complète",
          description: "Refonte totale d’un logement (maison ou appartement). Tous les lots sont traités : sols, murs, électricité, plomberie, menuiserie, isolation et finitions. Le chantier est coordonné de bout en bout dans un ordre logique."
        },
        multiSector: {
          title: "Rénovation partielle",
          description: "Interventions ciblées sur certaines pièces ou éléments (ex : cuisine, salle de bain, revêtements, électricité), sans reprendre l’ensemble du bien. Possibilité de combiner plusieurs lots selon vos besoins."
        },
        // Alias pour compatibilité avec l'ancien code
        multisectoral: {
          title: "Rénovation partielle",
          description: "Interventions ciblées sur certaines pièces ou éléments (ex : cuisine, salle de bain, revêtements, électricité), sans reprendre l’ensemble du bien. Possibilité de combiner plusieurs lots selon vos besoins."
        }
      },
      interior: {
        title: "Rénovation intérieure",
        categories: {
          painting: {
            title: "Peinture",
            image: "/images/categories/painting.jpg",
            subcategories: [
              "Murs intérieurs",
              "Plafonds",
              "Effets décoratifs (stucco, enduits spéciaux)",
              "Rénovation de boiseries intérieures"
            ]
          },
          flooring: {
            title: "Sol",
            image: "/images/categories/flooring.jpg",
            subcategories: [
              "Parquet (pose, ponçage, vitrification)",
              "Carrelage",
              "Moquette",
              "Sols vinyles / PVC",
              "Béton ciré"
            ]
          },
          plumbing: {
            title: "Plomberie",
            image: "/images/categories/plumbing.jpg",
            subcategories: [
              "Salles de bain",
              "WC",
              "Cuisines",
              "Remplacement de tuyauterie",
              "Chauffe-eau et ballons"
            ]
          },
          electrical: {
            title: "Électricité",
            image: "/images/categories/electrical.jpg",
            subcategories: [
              "Mise aux normes",
              "Remplacement tableau électrique",
              "Éclairage intégré / LED",
              "Réseau domotique"
            ]
          },
          partitions: {
            title: "Cloisons / Placo",
            image: "/images/categories/partitions.jpg",
            subcategories: [
              "Pose de cloisons en placoplâtre",
              "Faux plafonds",
              "Doublage phonique / thermique"
            ]
          },
          interiorJoinery: {
            title: "Menuiserie intérieure",
            image: "/images/categories/interiorJoinery.jpg",
            subcategories: [
              "Portes intérieures",
              "Plinthes / moulures",
              "Rangements / dressings sur mesure"
            ]
          },
          kitchen: {
            title: "Cuisine",
            image: "/images/categories/kitchen.jpg",
            subcategories: [
              "Montage de cuisine",
              "Plan de travail",
              "Crédence",
              "Électroménager encastré"
            ]
          },
          bathroom: {
            title: "Salle de bain",
            image: "/images/categories/bathroom.jpg",
            subcategories: [
              "Douche / baignoire",
              "Meuble vasque",
              "Carrelage mural",
              "Étanchéité"
            ]
          },
          heating: {
            title: "Chauffage",
            image: "/images/categories/heating.jpg",
            subcategories: [
              "Radiateurs",
              "Chauffage au sol",
              "Chaudière gaz / fioul",
              "Pompe à chaleur"
            ]
          },
          interiorInsulation: {
            title: "Isolation intérieure",
            image: "/images/categories/interiorInsulation.jpg",
            subcategories: [
              "Murs",
              "Combles",
              "Plancher bas",
              "Correction acoustique"
            ]
          },
          masonry: {
            title: "Maçonnerie",
            image: "/images/categories/masonry.jpg",
            subcategories: [
              "Ouvertures (portes, fenêtres)",
              "Murs porteurs",
              "Cloisons en briques",
              "Chapes et dalles"
            ]
          },
          carpentry: {
            title: "Charpente",
            image: "/images/categories/carpentry.jpg",
            subcategories: [
              "Structure bois",
              "Structure métallique",
              "Renforcement",
              "Traitement bois"
            ]
          },
          plastering: {
            title: "Plâtrerie",
            image: "/images/categories/plastering.jpg",
            subcategories: [
              "Enduits",
              "Plafonds",
              "Corniches",
              "Moulures"
            ]
          },
          tiling: {
            title: "Carrelage",
            image: "/images/categories/tiling.jpg",
            subcategories: [
              "Murs",
              "Sols",
              "Façades",
              "Piscines"
            ]
          },
          woodwork: {
            title: "Menuiserie bois",
            image: "/images/categories/woodwork.jpg",
            subcategories: [
              "Parquet",
              "Lambris",
              "Escaliers",
              "Meubles sur mesure"
            ]
          },
          security: {
            title: "Sécurité",
            image: "/images/categories/security.jpg",
            subcategories: [
              "Alarme intrusion",
              "Détecteurs de fumée",
              "Vidéosurveillance",
              "Contrôle d'accès",
              "Interphone / Visiophone",
              "Serrure connectée"
            ]
          },
          airConditioning: {
            title: "Climatisation",
            image: "/images/categories/airConditioning.jpg",
            subcategories: [
              "Climatisation réversible",
              "Pompe à chaleur air/air",
              "Ventilation mécanique",
              "Dépoussiérage",
              "Filtrage d'air",
              "Régulation thermique"
            ]
          }
        }
      },
      exterior: {
        title: "Rénovation extérieure",
        categories: {
          facade: {
            title: "Façade",
            image: "/images/categories/facade.jpg",
            subcategories: [
              "Ravalement",
              "Peinture extérieure",
              "Enduits",
              "Bardage"
            ]
          },
          roofing: {
            title: "Toiture",
            image: "/images/categories/roofing.jpg",
            subcategories: [
              "Réfection complète",
              "Zinguerie",
              "Isolation toiture",
              "Nettoyage / démoussage"
            ]
          },
          exteriorJoinery: {
            title: "Menuiserie extérieure",
            image: "/images/categories/exteriorJoinery.jpg",
            subcategories: [
              "Portes d'entrée",
              "Fenêtres (PVC, bois, alu)",
              "Volets",
              "Stores"
            ]
          },
          terrace: {
            title: "Terrasse",
            image: "/images/categories/terrace.jpg",
            subcategories: [
              "Pose de dalles",
              "Lames de bois / composite",
              "Étanchéité",
              "Garde-corps"
            ]
          },
          fencing: {
            title: "Clôtures / Portails",
            image: "/images/categories/fencing.jpg",
            subcategories: [
              "Maçonnerie de clôture",
              "Grillage",
              "Portail motorisé",
              "Portillon"
            ]
          },
          garden: {
            title: "Jardin",
            image: "/images/categories/garden.jpg",
            subcategories: [
              "Aménagement paysager",
              "Éclairage extérieur",
              "Arrosage automatique",
              "Allées et chemins"
            ]
          },
          exteriorInsulation: {
            title: "Isolation extérieure (ITE)",
            image: "/images/categories/exteriorInsulation.jpg",
            subcategories: [
              "Enduit isolant",
              "Bardage",
              "Panneaux isolants",
              "Ventilation"
            ]
          },
          drainage: {
            title: "Assainissement",
            image: "/images/categories/drainage.jpg",
            subcategories: [
              "Évacuation des eaux",
              "Drainage",
              "Fosses septiques",
              "Réseaux"
            ]
          },
          foundation: {
            title: "Fondations",
            image: "/images/categories/foundation.jpg",
            subcategories: [
              "Renforcement",
              "Injection",
              "Drainage",
              "Étanchéité"
            ]
          },
          exteriorMasonry: {
            title: "Maçonnerie extérieure",
            image: "/images/categories/exteriorMasonry.jpg",
            subcategories: [
              "Murs de clôture",
              "Murets",
              "Escaliers extérieurs",
              "Allées"
            ]
          }
        }
      }
    },

    professional: {
      types: {
        title: "Types de Rénovation Professionnelle",
        complete: {
          title: "Rénovation complète",
          description: "Refonte totale d’un espace (maison ou appartement transformé en pro, local commercial, bureaux). Tous les lots sont traités et coordonnés du gros œuvre aux finitions."
        },
        multiSector: {
          title: "Rénovation partielle",
          description: "Interventions sur des pièces ou éléments spécifiques (ex : cuisine, sanitaires, revêtements, électricité) sans reprendre l’ensemble de l’espace. Combinaison possible de plusieurs lots ciblés."
        },
        // Alias pour compatibilité avec l'ancien code
        multisectoral: {
          title: "Rénovation partielle",
          description: "Interventions sur des pièces ou éléments spécifiques (ex : cuisine, sanitaires, revêtements, électricité) sans reprendre l’ensemble de l’espace. Combinaison possible de plusieurs lots ciblés."
        }
      },
      categories: {
        restoration: {
          title: "Restauration",
          image: "/images/categories/professional/restoration.jpg",
          subcategories: [
            "Restaurant",
            "Café / Salon de thé",
            "Snack / Point chaud",
            "Coin cuisine / Kitchenette partagée"
          ]
        },
        parking: {
          title: "Stationnement",
          image: "/images/categories/professional/parking.jpg",
          subcategories: [
            "Parking extérieur",
            "Parking souterrain",
            "Abri à vélos sécurisé",
            "Bornes de recharge pour véhicules électriques"
          ]
        },
        office: {
          title: "Bureaux et espaces professionnels",
          image: "/images/categories/professional/office.jpg",
          subcategories: [
            "Bureau indépendant",
            "Espace de coworking",
            "Salle de réunion",
            "Accueil / Réception"
          ]
        },
        security: {
          title: "Sécurité",
          image: "/images/categories/professional/security.jpg",
          subcategories: [
            "Vidéosurveillance",
            "Système d'alarme",
            "Contrôle d'accès (badge, digicode, interphone)",
            "Porte blindée / Serrurerie renforcée"
          ]
        },
        access: {
          title: "Accès et élévation",
          image: "/images/categories/professional/access.jpg",
          subcategories: [
            "Ascenseur",
            "Escalier intérieur ou extérieur",
            "Système d'accès sécurisé",
            "Élargissement ou modification des accès verticaux existants"
          ]
        }
      }
    }
  }
};
